import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/var/www/alligator/article-preview/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/alligator/article-preview/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/var/www/alligator/article-preview/styles/globals.css");
